import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Typography, Box, Alert } from '@mui/material';
import "../restinfo/email.css";

const EmailTab = () => {
  const [contractors, setContractors] = useState([]);
  const [selectedContractor, setSelectedContractor] = useState('');
  const [emails, setEmails] = useState([]);
  const [editingEmails, setEditingEmails] = useState({});
  const [newEmails, setNewEmails] = useState({});
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [newEmail, setNewEmail] = useState('');
  
  
  useEffect(() => {
    fetchContractors();
  }, []);

  const fetchContractors = async () => {
    try {
      const { data } = await axios.get('https://hub2.daolog.net/contractors-email');
      setContractors(data);
    } catch (error) {
      setError('Помилка при завантаженні контрагентів');
      console.error('Error fetching contractors:', error);
    }
  };

  const fetchEmails = async (contractorId) => {
    try {
      const { data } = await axios.get(`https://hub2.daolog.net/contractor-emails-s/${contractorId}`);
      setEmails(data);
    } catch (error) {
      setError('Помилка при завантаженні пошти');
      console.error('Error fetching emails:', error);
    }
  };

  const handleContractorChange = (e) => {
    const contractorId = e.target.value;
    setSelectedContractor(contractorId);
    if (contractorId) {
      fetchEmails(contractorId);
    } else {
      setEmails([]);
    }
    setError('');
    setSuccess('');
    setEditingEmails({});
    setNewEmails({});
    setNewEmail('');
  };

  const handleDeleteEmail = async (emailId) => {
    if (!emailId) {
      setError('ID електронної пошти не визначено');
      return;
    }
    try {
      await axios.delete(`https://hub2.daolog.net/delete-email/${emailId}`);
      setSuccess('Пошту успішно видалено');
      fetchEmails(selectedContractor);
    } catch (error) {
      setError('Помилка при видаленні пошти');
      console.error('Error deleting email:', error);
    }
  };

  const handleEditEmail = (email) => {
    setEditingEmails(prev => ({
      ...prev,
      [email.id]: true
    }));
    setNewEmails(prev => ({
      ...prev,
      [email.id]: email.email
    }));
    setError('');
    setSuccess('');
  };

  const handleUpdateEmail = async (emailId) => {
    if (!emailId) {
      setError('ID електронної пошти не визначено');
      return;
    }
    try {
      await axios.put(`https://hub2.daolog.net/update-email/${emailId}`, { 
        email: newEmails[emailId] 
      });
      setEditingEmails(prev => ({
        ...prev,
        [emailId]: false
      }));
      setSuccess('Пошту успішно оновлено');
      fetchEmails(selectedContractor);
    } catch (error) {
      setError('Помилка при оновленні пошти');
      console.error('Error updating email:', error);
    }
  };

  const handleAddEmail = async () => {
    if (!selectedContractor || !newEmail) {
      setError('Виберіть контрагента та введіть email');
      return;
    }
    try {
      await axios.post('https://hub2.daolog.net/add-contractor-email', {
        contractorId: selectedContractor,
        email: newEmail
      });
      setSuccess('Email успішно додано');
      setNewEmail('');
      fetchEmails(selectedContractor);
    } catch (error) {
      setError('Помилка при додаванні email');
      console.error('Error adding email:', error);
    }
  };

  return (
    <div className="br-m" >
      <div className="container-about-ll">
        <Typography variant="h5" gutterBottom>
          Управління поштою клієнтів
        </Typography>

        {(error || success) && (
          <Alert 
            severity={error ? "error" : "success"} 
            style={{ marginBottom: "10px" }}
          >
            {error || success}
          </Alert>
        )}

        <div className="contractor-select">
          <select 
            className="input-stl"
            style={{ marginTop: "10px", backgroundColor: "rgb(213, 220, 255)" }}
            value={selectedContractor} 
            onChange={handleContractorChange}
          >
            <option value="">Виберіть клієнта</option>
            {contractors.map(contractor => (
              <option key={contractor.id} value={contractor.id}>
                {contractor.name}
              </option>
            ))}
          </select>
        </div>

        {selectedContractor && (
          <div style={{ marginTop: "20px", display: 'flex', gap: '10px' }}>
            <input
              className="input-stl"
              style={{ flex: 1, backgroundColor: "rgb(213, 220, 255)" }}
              type="email"
              placeholder="Введіть новий email"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
            />
            <button 
              className="download-button-g"
              onClick={handleAddEmail}
            >
              Додати Email
            </button>
          </div>
        )}

        <Box sx={{ padding: 2 }}>
          <div className="emails-list">
            {emails.map(email => (
              <div key={email.id} className="email-item" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {editingEmails[email.id] ? (
                  <>
                    <input
                      className="input-stl"
                      style={{ flex: 1, backgroundColor: "rgb(213, 220, 255)" }}
                      type="email"
                      value={newEmails[email.id] || ''}
                      onChange={(e) => setNewEmails(prev => ({
                        ...prev,
                        [email.id]: e.target.value
                      }))}
                    />
                    <button 
                      className="download-button-g"
                      onClick={() => handleUpdateEmail(email.id)}
                    >
                      Зберегти
                    </button>
                    <button 
                      className="download-button-s"
                      onClick={() => setEditingEmails(prev => ({
                        ...prev,
                        [email.id]: false
                      }))}
                    >
                      Скасувати
                    </button>
                  </>
                ) : (
                  <>
                    <span style={{ flex: 1 }}>{email.email}</span>
                    <button 
                      className="download-button-f"
                      onClick={() => handleEditEmail(email)}
                    >
                      Змінити
                    </button>
                    <button 
                      className="download-button-s"
                      onClick={() => handleDeleteEmail(email.id)}
                    >
                      Видалити
                    </button>
                  </>
                )}
              </div>
            ))}
          </div>
        </Box>
      </div>
    </div>
  );
};

export default EmailTab;